import React from "react";
import { Oval } from "react-loader-spinner";

function Loader() {
  return (
    <div>
      <Oval
        height={90}
        width={90}
        color="#4fa94d"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
        ariaLabel="oval-loading"
        secondaryColor="#4fa94d"
        strokeWidth={2}
        strokeWidthSecondary={2}
      />
    </div>
  );
}

export default Loader;
